import CreatorsDataTable from '../components/CreatorsDataTable';
import SEO from '../components/SEO';

export default function PolandCreators() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Top Polish Travel Creators & Influencers | Waybook"
        description="Discover the best travel content creators and influencers from Poland. Get inspired by Polish travel experiences and destinations."
        keywords="Polish travel creators, Poland travel influencers, Polish travel bloggers, Poland travel content"
        canonicalUrl="https://www.waybook.me/recommended/poland"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Poland Travel Creators',
          description: 'Top travel content creators from Poland',
          url: 'https://www.waybook.me/recommended/poland'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-4">🇵🇱 Poland Travel Creators</h1>
        <p className="text-gray-600 mb-8">
          Discover the best travel content creators from Poland
        </p>
        <CreatorsDataTable 
          countryFilter="PL"
          showFilters={false}
          title="Polish Creators"
          limit={20}
        />
      </div>
    </div>
  );
}
